import { render, staticRenderFns } from "./ProductPropertyGroup.vue?vue&type=template&id=59e9e1df&"
import script from "./ProductPropertyGroup.vue?vue&type=script&lang=js&"
export * from "./ProductPropertyGroup.vue?vue&type=script&lang=js&"
import style0 from "./ProductPropertyGroup.vue?vue&type=style&index=0&id=59e9e1df&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports